"use client";

import type { Table } from "@tanstack/react-table";
import { Settings2Icon } from "lucide-react";

import { Button } from "@/components/ui/button";
import {
	DropdownMenu,
	DropdownMenuCheckboxItem,
	DropdownMenuContent,
	DropdownMenuLabel,
	DropdownMenuSeparator,
	DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

interface DataTableViewOptionsProps<TData> {
	table: Table<TData>;
	columnsToRender: DataTableColumn<TData>[];
}

export interface DataTableColumn<TData> {
	id: keyof TData;
	label: string;
}

export function DataTableViewOptions<TData>({
	table,
	columnsToRender,
}: DataTableViewOptionsProps<TData> & {
	columnsToRender: DataTableColumn<TData>[];
}) {
	return (
		<DropdownMenu>
			<DropdownMenuTrigger asChild>
				<Button
					aria-label="Toggle columns"
					variant="outline"
					size="sm"
					className="ml-auto h-8"
				>
					<Settings2Icon className="mr-0 size-4" />
					Columnas
				</Button>
			</DropdownMenuTrigger>
			<DropdownMenuContent align="end" className="w-40">
				<DropdownMenuLabel>Mostrar u ocultar columnas</DropdownMenuLabel>
				<DropdownMenuSeparator />
				{table
					.getAllColumns()
					.filter(
						(column) =>
							typeof column.accessorFn !== "undefined" && column.getCanHide(),
					)
					.map((column) => {
						return (
							<DropdownMenuCheckboxItem
								key={column.id}
								className="capitalize"
								checked={column.getIsVisible()}
								onCheckedChange={(value) => column.toggleVisibility(!!value)}
							>
								<span className="truncate">
									{columnsToRender.find((c) => c.id === column.id)?.label}
								</span>
							</DropdownMenuCheckboxItem>
						);
					})}
			</DropdownMenuContent>
		</DropdownMenu>
	);
}
